<template>
    <div
        id="sources"
        class="col-12">
        <div class="box box-info">
            <div class="box-header">
                <h3 class="box-title">Seznam virov mailing liste</h3>
            </div>
            <div class="box-body table-responsive no-padding">
                <vuetable
                    ref="vuetable"
                    :api-url="api_route"
                    :fields="fields"
                    :css="css.table"
                    :row-class="rowClass"
                    :initial-page="initialPage"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :multi-sort="true"
                    :append-params="moreParams"
                    pagination-path="meta"
                    detail-row-component="source-details"
                    @vuetable:loaded="dataLoaded"
                    @vuetable:cell-clicked="onCellClicked"
                    @vuetable:pagination-data="onPaginationData"/>
            </div>
            <div class="box-footer clearfix">
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-left">
                    <p>Zadetkov na stran</p>
                    <select
                        v-model="perPage"
                        @change="changePerPage">
                        <option
                            v-for="option in perPageOptions"
                            :key="option"
                            :value="option">
                            {{ option }} / stran
                        </option>
                    </select>
                </div>
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-right">
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        info-template="Prikazujem {from} do {to} od {total} virov"
                        info-class="pagination-info"/>
                    <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        page-text="stran"
                        @vuetable-pagination:change-page="onChangePage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuetable               from 'vuetable-2/src/components/Vuetable';
import VuetablePagination     from 'vuetable-2/src/components/VuetablePagination';
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
import Table                  from '../../mixins/Table';
import TablePagination        from '../../mixins/TablePagination';

export default {
    name: 'MailingListDetails',

    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo
    },

    mixins: [
        Table,
        TablePagination
    ],

    props: {
        rowData:  {
            type:     Object,
            required: true
        },
        rowIndex: {
            type:    Number,
            default: 0
        }
    },

    data() {
        return {
            api_route: '/ajax/sources',

            fields: [
                {
                    name:      'id',
                    title:     '#',
                    sortField: 'id',
                },
                {
                    name:      '__component:source-label',
                    title:     'ime / oznaka',
                    sortField: 'name'
                },
                {
                    name:      'job_class_name',
                    title:     'job class',
                    callback:  value => value || 'n/a',
                    sortField: 'job_class_name',
                    dataClass: 'text-monospaced'
                },
                {
                    name:       'api',
                    title:      'zunanji API',
                    callback:   value => value ? '<span class="badge bg-green">da</span>' : '<span class="badge bg-yellow">ne</span>',
                    sortField:  'api',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
                {
                    name:       'auto_update',
                    title:      'avtomatsko posodabljaj',
                    callback:   value => value ? '<span class="badge bg-green">da</span>' : '<span class="badge bg-yellow">ne</span>',
                    sortField:  'auto_update',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
                {
                    name:      'connection',
                    title:     'povezava / podatkovna baza',
                    callback:  value => value || 'n/a',
                    sortField: 'connection'
                },
                {
                    name:      'table',
                    title:     'tabela',
                    callback:  value => value || 'n/a',
                    sortField: 'table'
                },
                {
                    name:       'contacts',
                    title:      'št. kontaktov',
                    callback:   value => value.toLocaleString('sl-SI') || 0,
                    sortField:  'contacts',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
                {
                    name:       'created_at',
                    title:      'ustvarjen',
                    callback:   value => this.formatDate(value, 'DD. MM. YYYY HH:mm:ss'),
                    sortField:  'created_at',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
                {
                    name:       'latest_import',
                    title:      'sinhroniziran',
                    callback:   value => this.formatDate(value, 'DD. MM. YYYY HH:mm:ss'),
                    sortField:  'latest_import',
                    titleClass: 'text-center',
                    dataClass:  'text-center'
                },
            ],

            perPage: 12,

            moreParams: {mailing_list_id: this.rowData.id},

            css: {
                table: {
                    tableClass: 'table table-striped table-hover'
                }
            },
        };
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MailingLists/MailingListDetails.vue